// MSAL's acquireTokenSilent/ssoSilent load redirectUri in a hidden iframe to
// capture the auth response hash. Since redirectUri is the SPA root (no spare
// blank.html route), that iframe loads the full app. Detecting this frame lets
// main.tsx hand the response to the main window instead of booting the app,
// which would throw block_iframe_reload:
// https://learn.microsoft.com/en-us/entra/identity-platform/msal-error-handling-js#block_iframe_reload
export const isMsalAuthFrame = (
  isFramed: boolean = window.parent !== window,
  hash: string = window.location.hash
): boolean => {
  if (!isFramed) return false;
  return /[#&](code|error)=/.test(hash);
};
